import { OfficeContext, OfficeRoutes } from "./OfficeRoutes";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { PageTabPanel } from "../../components/PageTabPanel/PageTabPanel";
import { AppContext } from "../../components/Menu/MenuButton";
import { ActionPromptType } from "../../hooks/prompts";

const OFFICE_TABS = [{
    name: 'Работа',
    context: `/${AppContext.Office}/${OfficeContext.Work}`,
    promptType: ActionPromptType.WORK_ADD,
}, {
    name: 'Бизнес',
    context: `/${AppContext.Office}/${OfficeContext.Business}`,
    promptType: ActionPromptType.BUSINESS_ADD,
}];

export const OfficePage = () => {
    return (
        <ContentWrapper noTopPadding={ true }>
            <PageTabPanel tabs={ OFFICE_TABS }/>
            <OfficeRoutes />
        </ContentWrapper>
    );
};
